import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import LandingHeader from "../components/LandingHeader";
import LandingFooter from "../components/LandingFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Agent Marketing by Elm Street Technology - Automated Marketing and Creative Design Services</title>
        <meta
          name="description"
          content="Agent Marketing by Elm Street Technology -  While AgentMarketing is going away, we have some other great product offerings within the Elm Street Family."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/agentmarketing" />
        <meta
          property="og:title"
          content="Agent Marketing by Elm Street Technology - While AgentMarketing is going away, we have some other great product offerings within the Elm Street Family."
        />
        <meta
          property="og:description"
          content="Agent Marketing by Elm Street Technology - While AgentMarketing is going away, we have some other great product offerings within the Elm Street Family."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />

      <LandingHeader />

      <div
        style={{
          backgroundImage: "url('/am/ambg.png')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
          fontFamily: "'Helvetica', 'Arial', sans-serif !important",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "40px",
            paddingRight: "40px",
            paddingTop: "50px",
            paddingBottom: "95px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={12} sm={12} style={{ textAlign: "center" }}>
                <div>
                  <Image
                    src="/am/am_logow.png"
                    width="400px"
                    height="99px"
                    alt="Agent Marketing by Elm Street Technology"
                  />
                </div>
              </Grid>

              <Grid item md={12} sm={12} style={{ textAlign: "center", paddingTop: "20px" }}>
                <h1 style={{ color: "#ffffff", fontSize: "40px", lineHeight: "55px" }}>
                  We want to thank you for your
                  <br />
                  loyalty &amp; support of AgentMarketing!
                </h1>

                <span style={{ color: "#1fa2dc", fontSize: "18px", lineHeight: "30px" }}>
                  <strong>
                    While we've closed the doors of AgentMarketing, we're opening a new one for you as an AgentMarketing
                    customer. Elm Street Technology has some great product offerings that can help with all your
                    business needs! Find out more information below!
                  </strong>
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div style={{ borderBottomColor: "#eaf0fc", borderBottomStyle: "solid", borderBottomWidth: "2px" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "35px",
            paddingRight: "35px",
            paddingTop: "85px",
          }}
        >
          <div style={{ marginTop: "25px", marginBottom: "-6px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12} style={{ paddingTop: "15px", paddingBottom: "35px" }}>
                <h3 variant="h4" component="h3">
                  <span style={{ color: "#1fa2dc" }}>Elevate</span> by Elm Street Technology <br />
                  for Agents/Brokers/Teams:
                </h3>
                <span>
                  Elevate is a revolutionary real estate platform that takes the reach, insight, and opportunity of
                  next-gen social media marketing and super-charges it with a best-in-class real estate CRM. With
                  Elevate, you reach your community where they spend their time, and have the tools you need to track,
                  prioritize, and capitalize on every conversation.
                </span>
                <br />
                <br />
                <Button
                  variant="contained"
                  color="secondary"
                  href="https://tryelevate.com/get-started"
                  target="_blank"
                  style={{ color: "#ffffff", backgroundColor: "#1fa2dc" }}
                >
                  learn more
                </Button>
              </Grid>

              <Grid item md={7} sm={12} style={{ paddingTop: "40px" }}>
                <div>
                  <Image
                    src="/am/elevate-glance.gif"
                    width="800px"
                    height="497px"
                    alt="Welcome to Elevate - by Elm Street Technology"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div style={{ borderBottomColor: "#eaf0fc", borderBottomStyle: "solid", borderBottomWidth: "2px" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "35px",
            paddingRight: "35px",
            paddingTop: "55px",
          }}
        >
          <div style={{ marginTop: "15px", marginBottom: "-6px" }}>
            <Grid container spacing={8}>
              <Grid item md={7} sm={12}>
                <div>
                  <Image
                    src="/am/oe-glance.gif"
                    width="800px"
                    height="497px"
                    alt="Welcome to OutboundEngine - by Elm Street Technology"
                  />
                </div>
              </Grid>

              <Grid item md={5} sm={12} style={{ paddingTop: "40px", paddingBottom: "65px" }}>
                <h3 variant="h4" component="h4">
                  <span style={{ color: "#1fa2dc" }}>OutboundEngine</span>
                  <br />
                  by Elm Street Technology
                  <br />
                  for Mortgage/Title:
                </h3>
                <span>
                  OutboundEngine provides the digital content savvy small business owners need to showcase their
                  expertise to their community, giving them back more time to focus on the conversations that build
                  sustainable, scaling businesses.
                </span>
                <br />
                <br />
                <Button
                  variant="contained"
                  color="secondary"
                  href="https://www.outboundengine.com/get-the-demo/"
                  target="_blank"
                  style={{ color: "#ffffff", backgroundColor: "#1fa2dc" }}
                >
                  learn more
                </Button>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundColor: "#001601",
          display: "block",
          fontFamily: "'Helvetica', 'Arial', sans-serif !important",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "35px",
            paddingRight: "35px",
            paddingTop: "25px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ textAlign: "center", paddingTop: "20px" }}>
            <h1 style={{ color: "#8abf3f", fontSize: "40px", lineHeight: "55px" }}>Questions about Text Codes?</h1>
            <strong style={{ color: "#ffffff" }}>Check out Voicepad&reg; for more information!</strong>
            <br />
            <br />

            <Button
              variant="contained"
              href="https://voicepad.com/curbside-lead-gen/"
              target="_blank"
              style={{ color: "#001601", backgroundColor: "#8abf3f" }}
            >
              learn more
            </Button>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundColor: "#eaf0fc",
          display: "block",
          fontFamily: "'Helvetica', 'Arial', sans-serif !important",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "35px",
            paddingRight: "35px",
            paddingTop: "55px",
            paddingBottom: "95px",
          }}
        >
          <div style={{ textAlign: "center", paddingTop: "20px" }}>
            <h1 style={{ color: "#1fa2dc", fontSize: "40px", lineHeight: "55px" }}>
              Need more information about
              <br />
              AgentMarketing shutting down?
            </h1>
            <strong>
              Please contact us today. We are more than happy to answer any questions <br />
              or provide additional information if needed.
            </strong>
            <br />
            <br />

            <Button
              variant="contained"
              href="mailto:help@agentmarketing.com"
              target="_blank"
              style={{ color: "#eaf0fc", backgroundColor: "#1fa2dc" }}
            >
              contact us today
            </Button>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundColor: "#333666",
          display: "block",
          textAlign: "center",
          fontFamily: "'Helvetica', 'Arial', sans-serif !important",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "35px",
            paddingRight: "35px",
            paddingTop: "35px",
            paddingBottom: "55px",
          }}
        >
          <div style={{ marginTop: "55px", marginBottom: "30px", textAlign: "center" }}>
            <Grid container spacing={12}>
              <Grid item md={12} sm={12} style={{ textAlign: "center" }}>
                <div>
                  <Image
                    src="/am/am_logow.png"
                    width="300px"
                    height="74px"
                    alt="Agent Marketing by Elm Street Technology"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
